module.exports = __webpack_public_path__ + "assets/img/775f-mo.svg";